import { Wrench, ShieldCheck, LifeBuoy, Home } from 'lucide-react';
import CTA from '../Cta';
import GasServiceImg from '../../img/Gas-service-img.png';

function GasServiceRepair() {
    return (
        <div className="chimney-repair-container">
            {/* Hero Section - No content, just introductory information */}
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Expert Gas Service Repair Solutions</h1>
                    <p className="chimney-repair-subtitle">
                        Our expert gas service repair solutions are designed to ensure the safe and efficient operation of your gas systems. Whether it's a gas leak, installation, or general gas system maintenance, we are here to make sure your home is safe and functional. Gas service issues, if left unchecked, can lead to safety hazards, health risks, and significant damage.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Trust our certified technicians to provide reliable and affordable gas service solutions, tailored to meet the specific needs of your home or business. From installation to repairs and maintenance, we deliver comprehensive gas system solutions, ensuring safety and long-lasting performance.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Regular maintenance and timely repairs can significantly extend the life of your gas system and prevent costly damage. We offer full-service repairs, including gas leak detection, pipe inspections, and restoration of your gas system’s functionality. Our team is equipped with the latest tools and knowledge to handle all gas service-related issues.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Don’t wait for a problem to escalate. Our gas services are designed to address even the smallest issues before they become major concerns. Let us help you keep your home safe, efficient, and ready for any gas-related needs with our expert gas service repair solutions.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:70390 34000")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={GasServiceImg} alt="Gas Service Repair" />
            </div>

            {/* Section 1: Why Choose Us */}
            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Gas Service Repair?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Wrench size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Skilled Technicians</h3>
                            <p className="chimney-repair-description">
                                Our technicians are experts trained in the latest gas service repair techniques, ensuring the highest quality and safety standards.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Safety First</h3>
                            <p className="chimney-repair-description">
                                We prioritize your safety by adhering to all local codes and regulations for gas systems, ensuring the safe operation of your gas service.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <LifeBuoy size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Emergency Services</h3>
                            <p className="chimney-repair-description">
                                Available 24/7 to handle emergency gas issues and restore your home’s safety and comfort as quickly as possible.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Affordable Solutions</h3>
                            <p className="chimney-repair-description">
                                We offer affordable, reliable repair and maintenance solutions without compromising on quality.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Our Process */}
            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Gas Service Repair Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Our team conducts a thorough inspection of your gas system to diagnose any issues and determine the best course of action.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Repair Plan</h3>
                        <p className="chimney-repair-step-description">
                            We provide you with a clear, upfront repair plan and cost estimate, ensuring transparency and no hidden fees.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Efficient Repair</h3>
                        <p className="chimney-repair-step-description">
                            Our skilled technicians work quickly and efficiently to resolve any issues with your gas system, ensuring minimal disruption.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Final Check</h3>
                        <p className="chimney-repair-step-description">
                            After repairs are completed, we perform a final check to ensure your gas system is operating safely and effectively.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default GasServiceRepair;
